<template>
  <div class="bbp-file-cell" v-if="fileId" @click.stop="openFile">
    <transition name="bbp-fade" appear>
      <BBPLoader v-if="loaderRun"></BBPLoader>
    </transition>
    <span
      v-if="popupIcon"
      v-html="popupIcon()"
      class="bbp-file-cell__icon"
    />
    <i
      v-else
      class="bbp-icon-eye bbp-toolbar-icon bbp-toolbar-icon_blue"
    />
  </div>
</template>

<script>
import {get} from 'lodash'
import FilesApi from '@/api/Files/api'
import b64toBlob from 'b64-to-blob'
import {saveAs} from 'file-saver'
import BBPLoader from '@/components/Main/BBPLoader/BBPLoader'
export default {
  name: 'BBPFileCell',
  props: ['row', 'column', 'fromParams'],
  components: {
    BBPLoader
  },
  data () {
    return {
      files: {},
      loaderRun: false
    }
  },
  computed: {
    popupIcon () {
      const { file = {} } = this.column
      const { icon } = file
      return icon
    },
    fileId () {
      const prop = this.fromParams ? get(this.column, 'file.prop', '') : this.column.prop
      return get(this.row, prop, '')
    },
    serverFile () {
      const prop = this.fromParams ? 'file.from' : 'from'
      return get(this.column, prop, '')
    }
  },
  methods: {
    openFile () {
      this.files[this.fileId]
        ? saveAs(this.files[this.fileId].blob, this.files[this.fileId].label)
        : this.getFile(this.fileId)
    },
    getFile (fileId) {
      this.loaderRun = true
      FilesApi.getFile(fileId)
        .then(resp => {
          const blob = b64toBlob(resp.data.base64, resp.data.type)
          this.files[resp.data.id] = {id: resp.data.id, blob, label: resp.data.label}
          saveAs(blob, resp.data.label)
          this.loaderRun = false
        })
        .catch(err => {
          console.error(err)
          this.loaderRun = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../sass/variables";
  @import "../../../../sass/mixins";

  .bbp-file-cell {
    display: inline-flex;
    align-items: center;
    justify-content: center;

    &__icon {
      width: 20px;
      height: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      background: $color-wild-sand;
      margin: 0 0 0 10px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/BBPTable/BBPFileCell/BBPFileCell.vue